import React, { useEffect, useCallback } from 'react'
import { Panel, Progress, Container, Label, TyanEllipsisLabel, Tool, Tooltip } from '@sencha/ext-modern'

import { getFileIcon, getFileType, getUuid } from 'tyan/public'
import { doUpload, getDownloadUrl, doDownload } from './fileServeDispatch'
import { useInstData, useEventHandler, useDelayTimer } from 'tyan/public/hooks'
import { genFileText } from '.'
import MyImage from './MyImage'
import Form from '../../Form'

const genToolProps = (icon, ui) => ({
	iconCls: `x-fa fa-${icon}`,
	ui: `size14 ${ui || 'action'}`,
	padding: '0 0 0 4px'
})

const Attachment = ({
	value, value: { FID }, imageSize, param,remain, valuesCount, 
	disabled, disableDelete, disableRename, disableEdit,
	onRemoveValue, onChangeValue,
	sortField, expansion, editFields, EditComp,
	isFirst, isLast, onSortValue,
	rotatable, onRotate, showUploadPerson, showUploadTime
}) => {
	const { me, me: { state: { xhr, upload, progress, displayButton, uploadPerson, uploadTime } }, setState } = useInstData()
	const iconCls = getFileIcon(value.FileExt)
	const fileType = getFileType(iconCls)
	const isSingle = remain + valuesCount <= 1

	const isTouch = Ext.platformTags.touch
	// value.FileName && value.FileExt && value.FileName.endsWith(value.FileExt) && (value.FileName = value.FileName.substring(0, value.FileName.length - value.FileExt.length))
	const handleAbortXhr = useEventHandler(() => {
		xhr && xhr.abort()
		setState({ xhr: undefined, upload: false })
	})

	const doShowButtons = useCallback(() => { setState(({ displayButton }) => displayButton ? null : { displayButton: true }) }, [])
	const doHideButtons = useCallback(() => { setState(({ displayButton }) => displayButton ? { displayButton: false } : null) }, [])

	const { doDelay: delayHideButtons } = useDelayTimer(5000)
	const showButtons = useCallback(() => {
		if (!isTouch) return

		delayHideButtons(doHideButtons)
		setTimeout(doShowButtons)
	}, [isTouch])

	const handleImageTap = useCallback(showImgDlg => {
		!isTouch
			? showImgDlg && showImgDlg()
			: (me.showImgDlg = showImgDlg, showButtons())
	}, [isTouch])

	const handleDownload = useEventHandler(() => {
		if (xhr) return
		const onSuccess = (url) => {
			setState({ xhr: undefined })
			const a = document.createElement('a')
			a.download = value.FileName + value.FileExt || getUuid()
			a.href = url
			/* !Ext.platformTags.desktop && ( */a.target = '_blank'/* ) */
			a.click()
			setTimeout(() => window.URL.revokeObjectURL(url), 10000)
			// Ext.toast(value.FileName + ' 下载完成')
		}
		const onProgress = (progress) => setState({ progress })
		const onError = (msg) => {
			setState({ xhr: undefined })
			!msg && (msg = '文件下载失败')
			Tyan.pubForm.showError(msg)
		}
		setState({ xhr: doDownload({ value, onSuccess, onProgress, onError }), progress: 0 })
	})

	const showImage = useEventHandler(useCallback(() => {
		me.showImgDlg ? me.showImgDlg() : window.open(getDownloadUrl(value))
	}, [value]))
	// const showImage = useEventHandler(() => handleDownload(true))

	// const 

	const listeners = {
		mouseenter: { element: 'bodyElement', fn: doShowButtons },
		mouseleave: { element: 'bodyElement', fn: doHideButtons }
	}

	// const handleRenameValue = useEventHandler(() => onRenameValue(value))
	const handleRenameValue = useEventHandler(() => {
		const onSave = v => onChangeValue(value, v)
		Tyan.pubForm.showDialog('修改文件信息', EditComp, { data: value, onSave, sortField, expansion, editFields })
	})

	const handleRemoveValue = useEventHandler(() => onRemoveValue(value))
	// const handleEditValue = useEventHandler(() => onEditValue(value))
	const handleEditValue = useEventHandler(() => {
		const { id, FileName, FileExt } = value

		const onSave = v => {
			const { FID, size: FileSize } = v
			const changedValues = { FID, FileSize, Text: genFileText(FileName, FileExt, FileSize) }
			onChangeValue(value, changedValues)
		}

		// 保存编辑后的图片
		const onSaveImage = blob => {
			// 上传文件到后台
			const file = new File([blob], `${FileName}.jpg`, { type: "image/jpeg" })

			const onSuccess = ({ FID }) => {
				setState({ xhr: null, upload: false })
				onChangeValue(value, { FID, FileExt: '.jpg', FileSize: file.size })
			}
			const onError = msg => setState({ xhr: null, upload: false, status: FILESERVE_STATUS.ERROR, message: (msg || '上传失败') })
			const onProgress = progress => setState({ progress })

			setState({ upload: true, xhr: doUpload({ blob: file, onSuccess, onError, onProgress, eventData: { FileSize: file.size, FileExt: '.jpg' }, param }) })
		}
		// Tyan.pubForm.showFrontEditor({ file, onSave: handleSave })

		// const fileType = getFileType(getFileIcon(FileExt))

		fileType === 'Image'
			? Tyan.pubForm.showImageEditor({ url: getDownloadUrl(value), onSave: onSaveImage/* , onCancel: () => console.log('cancelled') */ })
			: Tyan.pubForm.showFrontEditor({ file: value, onSave })
	})

	const handleMoveDown = useEventHandler(() => onSortValue(value))

	const handleMoveUp = useEventHandler(() => onSortValue(value, true))

	const renderNormal = (isImage = false) => {
		// console.log('value:', value.id, value.orderNo)
		return <Panel layout={{ type: 'hbox', pack: 'start' }}
			{...isImage ? { ui: 'half-transparent', right: 0, bottom: 0, height: 32, width: '100%' } : { listeners }}
		>
			{!isImage && <Tool {...genToolProps(xhr ? 'download' : `file-${iconCls}`)} padding='0 4 0 0' handler={showImage} /> || null}
			<Container layout='vbox' style='flex-shrink: 1'
				{...isImage ? { flex: 1 } : {}}
			>
				<TyanEllipsisLabel margin="4 0 0 0" style={{ cursor: 'pointer' }}
					{...isImage ? {} : { listeners: { tap: { element: 'element', fn: isTouch ? showButtons : showImage } } }}
					html={/* isImage && isSingle ? '' :  */value && genFileText(value.FileName, value.FileExt, value.FileSize,
						showUploadPerson && uploadPerson, showUploadTime && uploadTime) || null
					}
				>
					{(expansion || editFields) && <Tooltip dismissDelay={0} showDelay={0} hideDelay={0} allowOver >
						<EditComp {...{ showBody: Form, data: value, expansion, editFields, isTooltip: true }} />
					</Tooltip> || null}
				</TyanEllipsisLabel>
				<Container style='vbox' height={3}>
					{xhr && (<Progress value={progress / 100.0} />)}
				</Container>
			</Container>
			<Container layout='hbox' margin="0 0 0 5">
				{xhr
					? <>
						<Container layout={{ type: 'hbox', pack: 'end' }} minWidth='30'>
							<Label html={`${Math.ceil(progress) + '%'}`} padding="0" margin="4 0 0 0" />
						</Container>
						<Tool key='abortdownload' ui={`${upload ? 'decline' : 'action'} size14`} iconCls="x-fa fa-stop-circle" handler={handleAbortXhr} />
					</>
					: <>
						{
							rotatable && fileType === 'Image'
								? <>
									<Tool key='rotate-90' {...genToolProps('undo')} handler={() => onRotate(value, -90)} hidden={!displayButton} tooltip='逆时针旋转90度' />
									<Tool key='rotate90' {...genToolProps('redo')} handler={() => onRotate(value, 90)} hidden={!displayButton} tooltip='顺时针旋转90度' />
								</>
								: null
						}
						<Tool key='showImage' {...genToolProps('eye')} handler={showImage} hidden={!displayButton} tooltip='查看' />
						<Tool key='download' {...genToolProps('download')} handler={handleDownload} hidden={!displayButton} tooltip='下载' />
						{isSingle ? null : <Tool key='rename' {...genToolProps('edit')}
							handler={handleRenameValue} hidden={value.ReadOnly || disabled || disableRename || !displayButton}
							tooltip='修改名称'
						/>}
						{sortField && !isSingle
							? <Tool key='moveup' {...genToolProps('arrow-up')} handler={handleMoveUp}
								disabled={isFirst} hidden={value.ReadOnly || disabled || disableRename || !displayButton}
								tooltip='上移'
							/> : null}
						{sortField && !isSingle
							? <Tool key='movedown' {...genToolProps('arrow-down')} handler={handleMoveDown}
								disabled={isLast} hidden={value.ReadOnly || disabled || disableRename || !displayButton}
								tooltip='下移'
							/> : null}
						{fileType ? <Tool key='edit' {...genToolProps(`file-${iconCls}`)}
							handler={handleEditValue} hidden={value.ReadOnly || disabled || disableEdit || !displayButton}
							tooltip='编辑'
						/> : null}
						<Tool key='remove' {...genToolProps('times', 'decline')}
							handler={handleRemoveValue} hidden={value.ReadOnly || disabled || disableDelete || !displayButton}
							tooltip='删除'
						/>
					</>
				}
			</Container>
		</Panel >
	}

	const renderImage = () => <Container layout='fit' key={FID} margin='5' listeners={listeners}	>
		<MyImage {...imageSize} src={getDownloadUrl(value)} fileName={value.FileName} handleImageTap={handleImageTap} />
		{(displayButton || xhr) && renderNormal(true)}
	</Container>

	useEffect(() => () => { me.state.xhr && me.state.xhr.abort() }, [])

	useEffect(() => {
		(showUploadPerson || showUploadTime) && Tyan.doPostEvent('GetFileInfo', {
			data: { FID },
			onEnd: ({ errorMessage, LastUploadPerson: uploadPerson, LastUploadTime: uploadTime }) => {
				if (errorMessage) {
					Ext.toast(errorMessage)
				} else {
					setState({ uploadPerson, uploadTime })
				}
			}
		})

	}, [FID, showUploadPerson, showUploadTime])

	return imageSize ? renderImage() : renderNormal()
}

export default Attachment